import { toWorkspacePath } from "@/features/Workspaces/workspaceRoutes";
// Import of the module

import { parseDateWithHours } from "@/lib/utils";
import i18n from "@/i18n";
import { Link } from "@heroui/link";
import { ColumnDef } from "@tanstack/react-table";

// Type of the fields in the table

export type InputFile = {
  id: number;
  created_at: string;
  updated_at: string;
  protocol?: string;
  connector?: string;
  path?: string;
  filename?: string;
  connector_config_id?: number | null;
  connector_config?: string | null;
  unique_attribute_id?: string;
  gmail_labels?: string;
};

// Definition of the columns

export const input_files_columns: ColumnDef<InputFile>[] = [
  {
    accessorKey: "id",
    header: "Id",
  },
  {
    accessorKey: "connector_config",
    header: "Connector Config",
    cell: ({ row }) => {
      const id = row.original.connector_config_id;
      const name = row.getValue("connector_config") as string | null | undefined;

      if (!id || !name) return "";

      return (
        <Link
          href={toWorkspacePath(`/admin/qtl - etl/connector_configs/${id}`)}
          className="text-xs"
          underline="hover"
        >
          {name}
        </Link>
      );
    },
  },
  {
    accessorKey: "protocol",
    header: "Protocol",
  },
  {
    accessorKey: "connector",
    header: "Connector",
  },
  {
    accessorKey: "path",
    header: "Path",
  },
  {
    accessorKey: "filename",
    header: "Filename",
  },
  {
    accessorKey: "gmail_labels",
    header: "Gmail Labels",
  },
  {
    accessorKey: "created_at",
    header: "Created At",
    cell: ({ row }) => {
      const val = row.getValue("created_at");
      return val ? parseDateWithHours(val as string) : null;
    },
  },
  {
    accessorKey: "updated_at",
    header: "Updated At",
    cell: ({ row }) => {
      const val =
        row.getValue("updated_at") || (row.original as any).loaded_updated_at;
      return val ? parseDateWithHours(val as string) : null;
    },
  },
  {
    id: "actions",
    header: () => <div className="text-right">Actions</div>,
    cell: ({ row }) => (
      <div className="flex justify-end gap-2">
        <Link
          href={toWorkspacePath(
            `/admin/qtl - etl/time_serie_files?input_file_id=${row.getValue(
              "id",
            )}`,
          )}
          className="text-xs"
          underline="hover"
        >
          Time Series Files
        </Link>
        <Link
          href={`${window.location.pathname}/${row.getValue("id")}`}
          className="text-xs"
          underline="hover"
        >
          {i18n.t("actions.edit")}
        </Link>
      </div>
    ),
    enableSorting: false,
  },
];
